import React, {Component, Fragment} from 'react';
import {Routes, Route} from 'react-router';
import {withTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {route} from "../../../routes";
import {
  OPERATION_CREATE,
  OPERATION_DUPLICATE,
  OPERATION_EDIT,
  OPERATION_GROUP,
  OPERATION_SELECTED
} from "../../../constants";
import {Modal} from "cw-styleguide-react";
import CoursesManageController from "../controllers/CoursesManageController";
import CoursesCreateEditController from "../controllers/CoursesCreateEditController";
import CoursesMassUpdateController from "../controllers/CoursesMassUpdateController";

import NotFoundController from "../../notFound/controllers/NotFoundController";

class CoursesView extends Component {
  /**
   * render
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.courses.manage.title')}</title>
        </Helmet>
        <BreadcrumbsItem to={route('courses')}>
          {this.props.t('view.courses.manage.breadcrumb')}
        </BreadcrumbsItem>

        {/* Delete Courses Modal */}
        <Modal
          show={this.props.modals.bulkDelete}
          title={this.props.t('local:view.courses.manage.modals.delete.title')}
          onCancel={() => this.props.toggleModal(['bulkDelete'], false)}
          onConfirm={() => this.props.deleteCourse(this.props.selected, route('coursesManage') + this.props.query)}
          ariaLabelCancel={this.props.t('local:view.courses.manage.modals.delete.ariaLabelCancel')}
          ariaLabelConfirm={this.props.t('local:view.courses.manage.modals.delete.ariaLabelConfirm')}
          html={this.props.t('local:view.courses.manage.modals.delete.description', {count:this.props.selected.size})}
        />

        {/* Archive Courses Modal */}
        <Modal
          show={this.props.modals.bulkArchive}
          title={this.props.t('local:view.courses.manage.modals.archive.title')}
          onCancel={() => this.props.toggleModal(['bulkArchive'], false)}
          onConfirm={() => this.props.archiveCourse(this.props.selected, route('coursesManage') + this.props.query)}
          ariaLabelCancel={this.props.t('local:view.courses.manage.modals.archive.ariaLabelCancel')}
          ariaLabelConfirm={this.props.t('local:view.courses.manage.modals.archive.ariaLabelConfirm')}
          html={this.props.t('local:view.courses.manage.modals.archive.description', {count:this.props.selected.size})}
       />

        {/* Rollback Courses Modal */}
        <Modal
          show={this.props.modals.bulkRollback}
          title={this.props.t('local:view.courses.manage.modals.rollback.title')}
          onCancel={() => this.props.toggleModal(['bulkRollback'], false)}
          onConfirm={() => this.props.rollbackCourse(this.props.selected, route('coursesManage') + this.props.query)}
          ariaLabelCancel={this.props.t('local:view.courses.manage.modals.rollback.ariaLabelCancel')}
          ariaLabelConfirm={this.props.t('local:view.courses.manage.modals.rollback.ariaLabelConfirm')}
          html={this.props.t('local:view.courses.manage.modals.rollback.description', {count:this.props.selected.size})}
        />

        {/* Delete Courses Modal */}
        <Modal
          show={this.props.modals.delete}
          title={this.props.t('local:view.courses.manage.modals.delete.title')}
          onCancel={() => this.props.toggleModal(['delete'], false)}
          onConfirm={() => this.props.deleteCourse([this.props.id], route('coursesManage') + this.props.query)}
          ariaLabelCancel={this.props.t('local:view.courses.manage.modals.delete.ariaLabelCancel')}
          ariaLabelConfirm={this.props.t('local:view.courses.manage.modals.delete.ariaLabelConfirm')}
          html={this.props.t('local:view.courses.manage.modals.delete.description',{count:1})}
       />

        {/* Archive Courses Modal */}
        <Modal
          show={this.props.modals.archive}
          title={this.props.t('local:view.courses.manage.modals.archive.title')}
          onCancel={() => this.props.toggleModal(['archive'], false)}
          onConfirm={() => this.props.archiveCourse([this.props.id], route('coursesManage') + this.props.query)}
          ariaLabelCancel={this.props.t('local:view.courses.manage.modals.archive.ariaLabelCancel')}
          ariaLabelConfirm={this.props.t('local:view.courses.manage.modals.archive.ariaLabelConfirm')}
          html={this.props.t('local:view.courses.manage.modals.archive.description', {count:1})}
        />

        {/* Rollback Courses Modal */}
        <Modal
          show={this.props.modals.rollback}
          title={this.props.t('local:view.courses.manage.modals.rollback.title')}
          onCancel={() => this.props.toggleModal(['rollback'], false)}
          onConfirm={() => {this.props.rollbackCourse([this.props.id], route('coursesManage') + this.props.query)}}
          ariaLabelCancel={this.props.t('local:view.courses.manage.modals.rollback.ariaLabelCancel')}
          ariaLabelConfirm={this.props.t('local:view.courses.manage.modals.rollback.ariaLabelConfirm')}
          html={this.props.t('local:view.courses.manage.modals.rollback.description', {count:1})}
        />

        <Routes>
          <Route index
                 element={<CoursesManageController  {...this.props}/>}/>
          <Route path={route('coursesDuplicate')}
                 element={<CoursesCreateEditController {...this.props} operation={OPERATION_DUPLICATE} />}/>
          <Route path={route('coursesCreate')}
                 element={<CoursesCreateEditController  {...this.props} operation={OPERATION_CREATE} />}/>
          <Route path={route('coursesEdit')}
                 element={<CoursesCreateEditController  {...this.props} operation={OPERATION_EDIT} />}/>
          <Route path={route('coursesUpdateByGroup')}
                 element={<CoursesMassUpdateController query={this.props.query} operation={OPERATION_GROUP} />}/>
          <Route path={route('coursesUpdateBySelected')}
                 element={<CoursesMassUpdateController  query={this.props.query} operation={OPERATION_SELECTED} />}/>
          <Route path="*" element={<NotFoundController   />} />
        </Routes>
      </Fragment>
    );
  }
}

export default withTranslation('local')(CoursesView);
